// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import {
  getFunctions,
  connectFunctionsEmulator,
  httpsCallable,
} from "firebase/functions";
import { getVertexAI, getGenerativeModel } from "firebase/vertexai";

// gemini-2.0-flash-lite-001

// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB3BnJZ-MwZxDP8hsdREr6BIctYdh2sTDQ",
  authDomain: "wingman-7f7b0.firebaseapp.com",
  projectId: "wingman-7f7b0",
  storageBucket: "wingman-7f7b0.firebasestorage.app",
  messagingSenderId: "700022326610",
  appId: "1:700022326610:web:7ffb917d5ee9e104cb668b",
  measurementId: "G-1QTHCF684E",
};

// Public reCAPTCHA Enterprise site key registered with Firebase App Check.
const recaptchaEnterpriseSiteKey =
  "6LcXOpUtAAAAAESGmsxzydJNSfK4K3JoFQ6dwWfM";

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Use Firebase's debug-token flow for local development. Register the token
// printed in the browser console before testing against enforced App Check.
if (import.meta.env.DEV) {
  (
    globalThis as typeof globalThis & {
      FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean | string;
    }
  ).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(recaptchaEnterpriseSiteKey),
  isTokenAutoRefreshEnabled: true,
});

export const db = getFirestore(app);
export const auth = getAuth(app);
// const analytics = getAnalytics(app);

// Initialize the Vertex AI service
const vertexAI = getVertexAI(app);

// Create a `GenerativeModel` instance with a model that supports your use case
export const model = getGenerativeModel(vertexAI, {
  // model: "gemini-2.0-flash-lite-001",
  // model: "gemini-2.0-flash",
  model: "gemini-2.5-flash",
    // model: "gemini-2.5-flash-lite",

});

// Initialize Functions and connect to emulator
export const functions = getFunctions(app);
// connectFunctionsEmulator(functions, "localhost", 5002);

export const analyzeConversationFunction = httpsCallable(
  functions,
  "analyzeConversation"
);
export const generateCompletionFunction = httpsCallable(
  functions,
  "generateCompletion"
);
export const generateMessageRecommendationsFunction = httpsCallable(
  functions,
  "generateMessageRecommendations"
);

export const extractTextFromImagesFunction = httpsCallable(
  functions,
  "extractTextFromImages"
);

export const generateMessageRecommendationsAnthropicFunction = httpsCallable(
  functions,
  "generateMessageRecommendationsAnthropic"
);

export const generateCompletionAnthropicFunction = httpsCallable(
  functions,
  "generateCompletionAnthropic"
);

export const analyzeConversationAnthropicFunction = httpsCallable(
  functions,
  "analyzeConversationAnthropic"
);

export const submitSupportRequestFunction = httpsCallable(
  functions,
  "submitSupportRequest"
);

export const createPendingAccountFunction = httpsCallable(
  functions,
  "createPendingAccount"
);

export const createUserAccountFunction = httpsCallable(
  functions,
  "createUserAccount"
);

export const createPortalLinkFunction = httpsCallable(
  functions,
  "createCustomerPortalSession"
);

export const createPaymentUpdatePortalSessionFunction = httpsCallable(
  functions,
  "createPaymentUpdatePortalSession"
);

export const createDirectCheckoutSessionFunction = httpsCallable(
  functions,
  "createDirectCheckoutSession"
);

export const createDirectSubscription = httpsCallable(
  functions,
  "createDirectSubscription"
);

export const createOneTimePayment = httpsCallable(
  functions,
  "createOneTimePayment"
);

export const createOneTimeCheckoutSession = httpsCallable(
  functions,
  "createOneTimeCheckoutSession2"
);
